<script>
import PartnerApi from "@/services/partner-api";
import PartnerZone from "@/router/views/zone/partner-zone-component";
import Layout from "../../layouts/main";
import CountriesApi from "@/services/countries-api";
import CampaignApi from "@/services/campaign-api";

export default {
  name: 'partner',
  components: { Layout, PartnerZone},

  props:{
    partnerId:{
        type:Number,
        default: null
    }

  },


  data() {
    return {

        partner:{
            longitude:10.17677,
            latitude:36.77574,
            country:null,
            city:null,
            sector:null,
            sectorAsSector:null,
        },
        dayOffOptions: [
            { code: 1, day: 'Lundi' },
            { code: 2, day: 'Mardi' },
            { code: 3, day: 'Mercredi' },
            { code: 4, day: 'Jeudi' },
            { code: 5, day: 'Vendredi' },
            { code: 6, day: 'Samedi' },
            { code: 7, day: 'Dimanche' },
        ],
        citiesList:[],
        countriesList:[],
        sectorsList:[],
        nearsOptions:[],
        selectedNearsOptions: new Map(),

        zoneKey:0,
        partnerStatusList:null
     
    };
  },

  mounted(){    
    this.getCountries()
    this.getSector()
    this.getNearOptions()
    if(this.partnerId){
        this.findPartnerById()

    }
    this.findAllPartnerStatus()

  },

  watch:{

    "partner.longitude": function(){
        this.zoneKey++
    },
    "partner.latitude": function(){
        this.zoneKey++
    },

    partnerId:function(){
        if(this.partnerId){
            this.findPartnerById()
        }
    },

    selectedCountry: function(){


        if(this.selectedCountry != null){
        this.getCities()
        }else{
        this.selectedCity=null
        this.citiesList=[]
        }
    },
  },

  computed:{
    selectedCountry: {
      get() {
        return this.partner.country;
      },
      set(newCountry) {
        this.partner.country = newCountry;
      },
    },
    selectedCity:{
        get() {
        return this.partner.city;
        },
        set(newCity) {
            this.partner.city = newCity;
        },
    },
    selectedSector:{
        get() {
            return this.partner.sectorAsSector
        },
        set(newSector) {
            this.partner.sectorAsSector = newSector;
        },
    },
    selectedPartnerStatus:{
        get() {
            return this.partner.partnerStatusDTO
        },
        set(newStatus) {
            this.partner.partnerStatusDTO = newStatus;
        },
    },

    selectedDayOff: {
        get() {
            return this.dayOffOptions.find(option =>  option.code == this.partner.dayOff) || null;
        },
        set(selectedOption) {
            this.partner.dayOff = selectedOption ? selectedOption.code : null;
        },
    },
    

  },

  methods:{

    findAllPartnerStatus(){
      PartnerApi.findAllPartnerStatus().then(partnerStatusList =>{
            if(partnerStatusList){
                this.partnerStatusList = partnerStatusList
            }
        })
    },

    updateSelection(near) {
        const newValue = this.selectedNearsOptions.get(near.near) === "1" ? "0" : "1";
        this.selectedNearsOptions.set(near.key.toString(), newValue);

    },

    isSelectedNearOption(key) {
        if (this.selectedNearsOptions.has(key)) {
        const value = this.selectedNearsOptions.get(key); 
        return value === "1"; 
        }
        return false;
    },

    getNearOptions() {
      PartnerApi.getNearOptions().then(result => {
        if (result) {
            this.nearsOptions = result; 
        }
      });
    },

    getSector(){
        CampaignApi.getSector().then(sector =>{
            if(sector){
                this.sectorsList = sector
            }
        })
    },


    findPartnerById(){
        PartnerApi.findPartnerById(this.partnerId).then(result => {
            if (result) {
                this.partner = result;
                
                result.nearList.forEach(near => {
                    this.selectedNearsOptions.set(near, "1");

                });

            }
        });
      }, 

 
      addPartner() {

        const partner = {
            id: this.partner.id,
            ownerName: this.partner.ownerName,
            countryId:  this.selectedCountry == null ? null :  this.selectedCountry.id,
            cityId: this.selectedCity == null ? null :  this.selectedCity.id,
            codePostal: this.partner.codePostal,
            name: this.partner.companyName,
            sector: this.selectedSector != null ? this.selectedSector.code : null,
            phone1: this.partner.phone1,
            phone2: this.partner.phone2,
            adresse: this.partner.address,
            dayOff: this.partner.dayOff,
            gps: this.partner.latitude + ";" +this.partner.longitude,
            purchasingPower: this.partner.purchasingPower,
            partnerNearsRequestDto:  Object.fromEntries(this.selectedNearsOptions), 
            partnerStatus:  this.selectedPartnerStatus == null ? null : this.selectedPartnerStatus.shortCode , 
        };

          PartnerApi.addPartner(partner).then(result => {
            if (result) {
                this.partner = result;
            }
        }); 
    }, 

        getCountries(){
            CountriesApi.getCountries().then(
                result => {
                    this.countriesList = result
                })
        },

        getCities(){
            CountriesApi.getCities(this.selectedCountry ? this.selectedCountry.id : null).then(
                result => {
                    this.citiesList = result
                    this.selectedCity = this.citiesList.find(c => c.name == this.partner.cityName )

                })
        },


  }

  
};
</script>


<template>
    <Layout>
      <div class="card m-md-4 m-0">
        <div v-if="partner" class="card-body ">

            <div class="row">
      <div class="col-8">
        <h2 class="card-title font-size-25 text-primary text-uppercase" style="font-size:25px;">{{ $t('partner.text.title') }} {{ partner.companyName  }} </h2>
      </div>

      <div class="col-4">
        <b-button variant="primary" @click="addPartner()" class="float-sm-right mt-2 mt-lg-0 mt-xl-0 mt-md-0 text-uppercase font-weight-bold" >
                     {{ $t('buttons.save') }}
            </b-button>
      </div>
    </div>



            <!-- <div class="mt-4 d-flex align-items-center">
                <img width="20px" src="@/assets/icons/settings.svg" style="cursor: pointer;" />
                <span class="text-dark text-uppercase font-size-16 font-weight-bold pt-2 pb-2 pl-2">{{ $t('partner.text.general') }}</span>
            </div> -->


            <div class="row mt-4">

                <div class="col-md-8 col-12 pr-md-4 p-md-2 p-0">

                    <div class="row">
                        <div class="col-md-6 col-12 pr-lg-0 pr-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.companyName')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.companyName')"  
                                class="col-lg-11 text-dark "  
                                v-model="partner.companyName" />
                            </b-form-group>

                        </div>
                        <div class="col-md-6 col-12 pl-lg-0 pl-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.ownerName')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.ownerName')"  
                                class="col-lg-11 text-dark "  
                                v-model="partner.ownerName" />
                             </b-form-group>
                        </div>
                    </div>

                    <div class="row">

                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                            <b-form-group class="font-weight-bold text-dark font-size-14" :label="$t('lists.countries.label')" label-for="">
                                <v-select  class="col-lg-11 style-vselect-big" :options="countriesList" :placeholder="$t('lists.countries.label')" label="name" v-model="selectedCountry">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                            </b-form-group>
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
                            <b-form-group class="font-weight-bold text-dark font-size-14" :label="$t('lists.cities.label')" label-for="">
                                <v-select class="col-lg-11 style-vselect-big" :options="citiesList" :placeholder="$t('lists.cities.label')" label="name" v-model="selectedCity">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                            </b-form-group>
                        </div>

                    </div>



                    <div class="row">
                        <div class="col-md-6 col-12 pr-lg-0 pr-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.address')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.address')"  
                                class="col-lg-11 text-dark "  
                                v-model="partner.address" />
                            </b-form-group>

                        </div>
                        <div class="col-md-6 col-12 pl-lg-0 pl-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.codePostal')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.codePostal')"  
                                class="col-lg-11 text-dark "  
                                v-model="partner.codePostal" />
                             </b-form-group>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-6 col-12 pr-lg-0 pr-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.phone1')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.phone1')"  
                                class="col-lg-11 text-dark "  
                                v-model="partner.phone1" />
                            </b-form-group>

                        </div>
                        <div class="col-md-6 col-12 pl-lg-0 pl-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.phone2')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.phone2')"  
                                class="col-lg-11 text-dark "  
                                v-model="partner.phone2" />
                             </b-form-group>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-6 col-12 pr-lg-0 pr-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.latitude')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.latitude')"  
                                class="col-lg-11 text-dark "  
                                type="number"
                                step="0.0001"
                                v-model="partner.latitude" />
                            </b-form-group>

                        </div>
                        <div class="col-md-6 col-12 pl-lg-0 pl-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.longitude')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.longitude')"  
                                class="col-lg-11 text-dark "  
                                type="number"
                                step="0.0001"
                                v-model="partner.longitude" />
                             </b-form-group>
                        </div>
                    </div>
                    

                    <div class="row">
                        <div class="col-md-6 col-12 pr-lg-0 pr-md-2">
                            <b-form-group class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.sector')" label-for="">
                                <v-select class="col-lg-11 style-vselect-big" :options="sectorsList" :placeholder="$t('partner.placeholder.sector')" label="sector" v-model="selectedSector">
                                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                            </b-form-group>

                        </div>
                        <div v-if="partnerStatusList" class="col-md-6 col-12 pr-lg-0 pr-md-2">
                            <b-form-group class="font-weight-bold text-dark font-size-14"  :label="$t('lists.status.filter')"  label-for="">
                                <v-select class="col-lg-11 style-vselect-big" :options="partnerStatusList" :placeholder="$t('lists.status.filter')" label="fullDescription" v-model="selectedPartnerStatus">
                                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                            </b-form-group>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 col-12 pl-lg-0 pl-md-2">
                            <b-form-group   class="font-weight-bold text-dark font-size-14" :label="$t('partner.input.purchasingPower')"  >
                                <b-form-input 
                                :placeholder="$t('partner.placeholder.purchasingPower')"  
                                class="col-lg-11 text-dark "  
                                type="number"
                                max="10"
                                min="0"
                                v-model="partner.purchasingPower" />
                             </b-form-group>
                        </div>

                        <div v-if="dayOffOptions" class="col-md-6 col-12 pl-lg-0 pl-md-2">
                            <!-- Jour de repos -->
                            <b-form-group  label-for="" class="font-weight-bold text-dark font-size-14"  :label="$t('partner.input.dayOff')">
                                <v-select class="col-lg-11 style-vselect-big"
                                        :options="dayOffOptions" 
                                        :placeholder="$t('partner.placeholder.dayOff')" 
                                        label="day" v-model="selectedDayOff">
                                    <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                                </v-select>
                            </b-form-group>
                        </div>
                    </div>
                   
                </div>



                <div class="col-md-4 col-12 p-lg-4 mt-md-0 mt-4">
                    <PartnerZone :key="zoneKey" v-if="partner" :partner="partner"/>

                </div>
            </div>


        <hr class="text-center mt-4" style="width: 90%;" >

            <div class="p-md-2 p-0">

                <div class="d-flex align-items-center mt-3">
                    <img width="20px" src="@/assets/icons/marker-near.svg" style="cursor: pointer;" />
                    <span class="text-dark text-uppercase font-size-16 font-weight-bold pt-2 pb-2 pl-2">{{ $t('partner.text.nears') }}</span>
                </div>


                <div class="text-dark font-size-14  pt-2 pb-2 "> {{ $t('partner.text.selecteNears') }}</div>

                <div v-if="nearsOptions && Object.keys(nearsOptions).length" class="row mt-3">
                    <div v-for="near in nearsOptions" :key="near.id" class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-12  p-2 product" :style="{'border-radius':'5px'}">                      
                        <b-form-checkbox  
                            :checked="isSelectedNearOption(near.key)"
                            :value="true"
                            :unchecked-value="false"
                            :style="near.active ? 'opacity: 1 !important;' : ''"
                            class="product-checkbox custom-checkbox custom-checkbox-success mb-0 mt-0 text-dark font-size-14"    
                            @change="updateSelection(near)"
                        >{{ near.near }}</b-form-checkbox> 

                    </div>
                </div>

            </div>


          




        </div>




      </div>
  
    </Layout>    
  </template>
  
  <style>



  .style-vselect-big .vs__search::placeholder,
  .style-vselect-big .vs__dropdown-toggle,
  .style-vselect-big .vs__search,
  .style-vselect-big .vs__dropdown-menu {
    line-height: 1.8;
    font-size: 1em;
    background: white;
  }

  .style-vselect-big .vs__clear,
  .style-vselect-big .vs__open-indicator {
    fill: #000; /*#d90100;*/
  }

</style>